export enum MediaClipType {
    DingDong = "DingDong",
    KioskCheckIn = "KioskCheckIn",
}
